// extracted by mini-css-extract-plugin
export default {"socialL3":"SocialL3_socialL3__B0iiI","pieGraph":"SocialL3_pieGraph__YR1rW","graph":"SocialL3_graph__3g3ot"};